<h3>Ficha de grupo</h3>

<div class="flex flex-row gap-4 h-full">
  <div class="btn btn-neutral-outline avatar !w-[6.6rem] !h-[6.6rem] overflow-hidden shrink-0">
    <div class="rounded-full aspect-square border-1 h-full w-full flex items-center justify-center bg-neutral-200"
         style="border-color: var(--color-neutral-300)">
      <img alt="Grupo" class="group-file-avatar-icon" src="/assets/icons/compliance/favorite.png">
    </div>
  </div>

  <div class="flex flex-col gap-1 w-full">
    <h6 class="pb-1">{{ group?.name || 'Grupo' }}</h6>
    <span class="cd-text-b3 text-neutral-600">{{ group?.description || 'Sin descripción' }}</span>
    <span class="cd-text-b3 text-neutral-600">{{ group?.function || 'Sin función definida' }}</span>
    <div class="flex flex-row flex-wrap gap-2 mr-auto">
      <span class="cd-text-b3 text-neutral-600">{{ courses.length }} Cursos</span>
      <span class="cd-text-b3 text-neutral-600">{{ policies.length }} Políticas</span>
      <span class="cd-text-b3 text-neutral-600">{{ employeesCount }} Empleados</span>
    </div>
  </div>
</div>

@if (managerTag) {
  <div class="flex gap-2 flex-row flex-wrap">
    <div class="outline primary truncate !py-1 !px-2 cd-text-b4 text-center flex flex-row gap-2">
      <img alt="Icon" class="filter-primary-600 h-4" src="/assets/icons/feather/user.svg">
      <span class="truncate">{{ managerTag }}</span>
    </div>
  </div>
}

<core-tabs [config]="[
    { slug: 'employees', label: 'Empleados asociados', template: employeesTabTpl},
    { slug: 'courses', label: 'Cursos asociados', template: coursesTabTpl},
    { slug: 'policies', label: 'Aceptación de políticas', template: policiesTabTpl},
    { slug: 'attachments', label: 'Archivos adjuntos', template: attachmentsTabTpl},
    { slug: 'notes', label: 'Notas', template: notesTabTpl}
  ]"/>

<ng-template #employeesTabTpl let-slug>
  @if (group?.employees?.length) {
    <div class="flex flex-row flex-wrap gap-2">
      @for (employee of group?.employees; track employee.id) {
        <div class="py-1 px-3 rounded-[1rem] flex flex-row items-center bg-neutral-200 gap-2">
          <span class="cd-text-b4 text-neutral-800">{{ employee.name }}</span>
          @if (employee.isManager) {
            <span class="outline primary !py-1 !px-2 cd-text-b5 whitespace-nowrap">Encargado</span>
          }
        </div>
      }
    </div>
  } @else {
    <span class="cd-text-b4 text-neutral-500">Sin empleados asociados.</span>
  }
</ng-template>

<ng-template #coursesTabTpl let-slug>
  @if (isLoadingCourses) {
    <div class="flex flex-col gap-2">
      @for (item of tabSkeletonItems; track item) {
        <div class="flex flex-row justify-between items-center bg-white rounded-xl p-3 shadow-e1">
          <div class="flex flex-col gap-2 flex-1 min-w-0">
            <div class="h-4 w-2/3 skeleton skeleton-rect rounded-md"></div>
            <div class="h-3 w-24 skeleton skeleton-rect rounded-md"></div>
          </div>
          <div class="h-4 w-16 skeleton skeleton-rect rounded-md shrink-0"></div>
        </div>
      }
    </div>
  } @else if (coursesError) {
    <span class="cd-text-b4 text-error-600">{{ coursesError }}</span>
  } @else if (courses.length) {
    <div class="flex flex-col gap-2">
      @for (course of courses; track course.id) {
        <div class="flex flex-row justify-between items-center bg-white rounded-xl p-3 shadow-e1 gap-3">
          <div class="flex flex-col min-w-0">
            <span class="cd-text-b3 font-medium">{{ course.name }}</span>
            <span class="cd-text-b5 text-neutral-500">{{ course.completed }}/{{ course.employees }} completados</span>
          </div>
          <span class="cd-text-b4 text-neutral-600 whitespace-nowrap">{{ course.progress ?? 0 }}%</span>
        </div>
      }
    </div>
  } @else {
    <span class="cd-text-b4 text-neutral-500">Sin cursos comunes para todos los miembros.</span>
  }
</ng-template>

<ng-template #policiesTabTpl let-slug>
  @if (isLoadingPolicies) {
    <div class="flex flex-col gap-2">
      @for (item of tabSkeletonItems; track item) {
        <div class="flex flex-row justify-between items-center bg-white rounded-xl p-3 shadow-e1">
          <div class="flex flex-col gap-2 flex-1 min-w-0">
            <div class="h-4 w-2/3 skeleton skeleton-rect rounded-md"></div>
            <div class="h-3 w-24 skeleton skeleton-rect rounded-md"></div>
          </div>
          <div class="h-4 w-16 skeleton skeleton-rect rounded-md shrink-0"></div>
        </div>
      }
    </div>
  } @else if (policiesError) {
    <span class="cd-text-b4 text-error-600">{{ policiesError }}</span>
  } @else if (policies.length) {
    <div class="flex flex-col gap-2">
      @for (policy of policies; track policy.id) {
        <div class="flex flex-row justify-between items-center bg-white rounded-xl p-3 shadow-e1 gap-3">
          <div class="flex flex-col min-w-0">
            <span class="cd-text-b3 font-medium">{{ policy.name }}</span>
            <span class="cd-text-b5 text-neutral-500">{{ policy.accepted }}/{{ policy.employees }} aceptadas</span>
          </div>
          <span class="cd-text-b4 text-neutral-600 whitespace-nowrap">{{ policy.acceptanceRate ?? 0 }}%</span>
        </div>
      }
    </div>
  } @else {
    <span class="cd-text-b4 text-neutral-500">Sin políticas comunes para todos los miembros.</span>
  }
</ng-template>

<ng-template #attachmentsTabTpl let-slug>
  <div class="group-file-tab-shell">
    <div class="group-file-tab-header">
      <div></div>
      <button class="btn btn-link self-start !px-0 group-file-top-link" type="button" (click)="attachmentInput.click()">
        <img alt="Icon" class="filter-neutral-800 h-4" src="/assets/icons/feather/upload.svg">
        <span>Agregar archivo adjunto</span>
      </button>
      <input #attachmentInput class="hidden" type="file" multiple (change)="handleAttachmentSelection($event)"/>
    </div>

    <div class="flex flex-col gap-2">
      @if (isLoadingAttachments) {
        @for (item of tabSkeletonItems; track item) {
          <div class="group-file-item-skeleton">
            <div class="h-8 w-8 skeleton skeleton-rect rounded-md shrink-0"></div>
            <div class="flex flex-col gap-2 flex-1 min-w-0">
              <div class="h-4 w-3/4 skeleton skeleton-rect rounded-md"></div>
              <div class="h-3 w-24 skeleton skeleton-rect rounded-md"></div>
            </div>
            <div class="h-8 w-8 skeleton skeleton-rect rounded-md shrink-0"></div>
          </div>
        }
      } @else if (pendingAttachmentPlaceholders.length) {
        @for (item of pendingAttachmentPlaceholders; track item) {
          <div class="group-file-item-skeleton">
            <div class="h-8 w-8 skeleton skeleton-rect rounded-md shrink-0"></div>
            <div class="flex flex-col gap-2 flex-1 min-w-0">
              <div class="h-4 w-3/4 skeleton skeleton-rect rounded-md"></div>
              <div class="h-3 w-24 skeleton skeleton-rect rounded-md"></div>
            </div>
            <div class="h-8 w-8 skeleton skeleton-rect rounded-md shrink-0"></div>
          </div>
        }
      } @else if (attachmentsError) {
        <span class="cd-text-b4 text-error-600">{{ attachmentsError }}</span>
      } @else if (attachments.length) {
        <div class="flex flex-col gap-2">
          @for (file of attachments; track file.id) {
            <core-file-widget
              class="border border-neutral-300 bg-white"
              [fileName]="file.fileName"
              [fileSize]="formatFileSize(file.fileSize)"
              [showRemove]="false"
              (download)="downloadAttachment(file)"/>
          }
        </div>
      } @else {
        <span class="cd-text-b4 text-neutral-500">Sin documentos adjuntos.</span>
      }
    </div>

  </div>
</ng-template>

<ng-template #notesTabTpl let-slug>
  <div class="group-file-tab-shell">
    <div class="flex flex-col gap-3">
      <div class="bg-white rounded-xl p-2.5 shadow-e1 flex flex-col gap-2.5">
        <textarea
          [(ngModel)]="noteDraft"
          [disabled]="isSubmittingNote"
          class="group-file-note-input"
          id="group-note"
          placeholder="Escribe una nota útil para el seguimiento del grupo"></textarea>
        <div class="flex items-center justify-end gap-3">
          @if (notesError && !isSubmittingNote) {
            <span class="cd-text-b5 text-error-600">{{ notesError }}</span>
          }
          <button class="btn btn-primary" type="button" [disabled]="isSubmittingNote || !noteDraft.trim()" (click)="submitNote()">
            {{ isSubmittingNote ? 'Guardando...' : 'Agregar nota' }}
          </button>
        </div>
      </div>

      @if (isLoadingNotes || isRefreshingNotes) {
        @for (item of tabSkeletonItems; track item) {
          <div class="flex flex-col gap-2 bg-white rounded-xl p-2.5 shadow-e1">
            <div class="h-4 w-40 skeleton skeleton-rect rounded-md"></div>
            <div class="h-3 w-full skeleton skeleton-rect rounded-md"></div>
            <div class="h-3 w-24 skeleton skeleton-rect rounded-md"></div>
          </div>
        }
      } @else if (notes.length) {
        <div class="flex flex-col gap-2">
          @for (note of notes; track note.id) {
            <div class="flex flex-col gap-1 bg-white rounded-xl p-2.5 shadow-e1">
              <div class="flex items-start gap-3">
                <span class="cd-text-b3 font-medium">{{ authorName(note) }}</span>
                <button class="btn btn-neutral-text !px-1 !py-1 ml-auto" type="button" [disabled]="isDeletingNote(note.id)" (click)="deleteNote(note.id)">
                  <img alt="Eliminar" class="h-4 filter-neutral-800" src="/assets/icons/feather/trash-2.svg">
                </button>
              </div>
              <span class="cd-text-b4 text-neutral-700 whitespace-pre-line">{{ note.content }}</span>
              <span class="cd-text-b5 text-neutral-500">{{ formatDate(note.createdAt) }}</span>
            </div>
          }
        </div>
      } @else {
        <span class="cd-text-b4 text-neutral-500">Sin notas registradas.</span>
      }
    </div>
  </div>
</ng-template>
